export const configureEmUtilization = "configureEmUtilization";
export const inValidFieldsAndMessages = [{
  "field": "E&M Bubble Chart and Bell Curve Settings : Default E&M Category",
  "message": "Please select Default E&M Category.",
},
{
  "field": "E&M Bubble Chart and Bell Curve Settings : Default Normative Data Source",
  "message": "Please select Default Normative Data Source.",
},
{
  "field": "Risk Score Configuration : Risk Score Normative Data Source",
  "message": "Please select Risk Score Normative Data Source.",
},
{
  "field": "Provider Data View Settings : Default E&M Category",
  "message": "At least one category must be selected.",
},
{
  "field": "E&M Bubble Chart and Bell Curve Settings : Default DOS Range",
  "message": "Invalid Default DOS Range.",
},
{
  "field": "Risk Score Configuration : Risk Score DOS Range",
  "message": "Invalid Risk Score DOS Range.",
}
];
export const CONFIGURE_EM_UILIZATION_WARNING_POPUP_MODE = {
  INVALID_FIELDS:"INVALID_FIELDS",
  INVALID_RISK_SCORE_WEIGHT:"INVALID_RISK_SCORE_WEIGHT",
  SAME_NORMATIVE_DATASOURCE:"SAME_NORMATIVE_DATASOURCE"

};
export const alternateNormativeDataSourceInfo = "Additional normative data source that can be used for comparison in the Data View Report";
export const riskScoreDOSRangeInfo = "Dates of service used to calculate the risk score. Also controls the date range for the Data View";
export const riskScoreWeightingItems = [{
    "arg": "Case Volume",
    "val": 40,
    "color": "#f8b217"
},
{
    "arg": "Normative Reimbursement Difference",
    "val": 20,
    "color": "#008896"
},
{
    "arg": "Rendering Provider Group Reimbursement Difference",
    "val": 10,
    "color": "#585859"
},
{
    "arg": "Normative Work RVU Difference",
    "val": 20,
    "color": "#cf2890"
},
{
    "arg": "Rendering Provider Group Work RVU Difference",
    "val": 10,
    "color": "#73b944"
}];